exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /code/frontend/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0